import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { CRM_READ_ONLY_UI_TOOLTIP, isProfileOrganizationCrmReadOnly } from '../utils/organization/crmReadOnly.util'

/**
 * Redux state → CRM write lock (use with `connect` in class components).
 * @param {object} state
 * @returns {{ locked: boolean, tooltip: string }}
 */
export function selectCrmWriteLock (state) {
  const organization = get(state, 'profile.data._organization')
  return {
    locked: isProfileOrganizationCrmReadOnly(organization),
    tooltip: CRM_READ_ONLY_UI_TOOLTIP
  }
}

/**
 * CRM write lock from the current profile's organization (Redux).
 * @returns {{ locked: boolean, tooltip: string }}
 */
export function useCrmWriteLock () {
  return useSelector(selectCrmWriteLock)
}
